import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './Editor.scss';

let Inline = Quill.import('blots/inline');
class MarkedBlot extends Inline { }
MarkedBlot.blotName = 'marked';
MarkedBlot.tagName = 'mark';
Quill.register('formats/marked', MarkedBlot);


const Editor = (props) => {
	const quillModules = {
		toolbar: [
			[{ header: [1, 2, 3, 4, 5, 6, false] }],
			["bold", "italic", "underline", "strike"],
			["blockquote", "code-block"],
			[{ list:  "ordered" }, { list:  "bullet" }],
			["link", "image", "video"],
		],
	}

	const allowedFormats = ['header', 'marked', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'list', 'link', 'image', 'video'];

	const handleContentChange = function (val) {
		if (props.contentCallback) {
			props.contentCallback(val);
		}
	}
	let content = props.content;
	return (
		<div className="editor">
			<ReactQuill theme="snow" modules={quillModules} onChange={handleContentChange} value={content} formats={allowedFormats} />
		</div>
	)
}

export default Editor;